<template>
  <div class="user-main">
    <img class="background-img" src="@/assets/images/IA/img_user_bk.png" alt="">
    <div class="user-main-frame">
      <div class="modal-cover" v-show="isGuide"/>
      <div class="menu-guide">
        <p class="p-guide">평가 받은 기록을 열람할 수 있습니다</p>
        <p class="p-guide">상지, 하지를 먼저 선택해주세요</p>
      </div>
      <div class="menu-pager-btn">
        <div v-if="isTypeUpper">
          <img class="btn-ue" src="@/assets/images/IA/btn_user_ue_active.png" alt="">
          <img class="btn-le" src="@/assets/images/IA/btn_user_le_disable.png" alt="" @click="isTypeUpper= false">
        </div>
        <div v-else>
          <img class="btn-ue" src="@/assets/images/IA/btn_user_ue_disable.png" alt="" @click="isTypeUpper= true">
          <img class="btn-le" src="@/assets/images/IA/btn_user_le_active.png" alt="">
        </div>
      </div>
      <div class="menu-box" v-if="isTypeUpper">
        <div class="menu-container">
          <div class="menu-item">
            <div class="item-status">
              <div class="item-useful" v-if="patientsInfo.lastfm" @click="report('fm')">
                <img class="icon-item" src="@/assets/images/IA/icon_new_document.png" alt="">
                <p class="p-status">평가 기록이 있습니다</p>
                <p class="p-day">마지막 평가일 : {{ patientsInfo.lastfm }}</p>
              </div>
              <div class="item-useful" v-else>
                <img class="icon-item" src="@/assets/images/IA/icon_null_document.png" alt="">
                <p class="p-status-null">평가 기록이 없습니다</p>
                <p class="p-day">마지막 평가일 : --</p>
              </div>
            </div>
            <div class="item-title-b">
              <p class="p-evaluation">전반적 상지 손상 검사(FM)</p>
              <img class="icon-info" src="@/assets/images/IA/icon_info_w.png" alt="" @click="showGuide(0)">
            </div>
          </div>
          <div class="menu-item">
            <div class="item-status">
              <div class="item-useful" v-if="patientsInfo.lastwmft" @click="report('wmft')">
                <img class="icon-item" src="@/assets/images/IA/icon_new_document.png" alt="">
                <p class="p-status">평가 기록이 있습니다</p>
                <p class="p-day">마지막 평가일 : {{ patientsInfo.lastwmft }}</p>
              </div>
              <div class="item-useful" v-else>
                <img class="icon-item" src="@/assets/images/IA/icon_null_document.png" alt="">
                <p class="p-status-null">평가 기록이 없습니다</p>
                <p class="p-day">마지막 평가일 : --</p>
              </div>
            </div>
            <div class="item-title-s">
              <p class="p-evaluation">상지 운동 검사(WMFT)</p>
              <img class="icon-info" src="@/assets/images/IA/icon_info_w.png" alt="" @click="showGuide(1)">
            </div>
          </div>
          <div class="menu-item">
            <div class="item-status">
              <div class="item-useful" v-if="patientsInfo.lastbb" @click="report('bb')">
                <img class="icon-item" src="@/assets/images/IA/icon_new_document.png" alt="">
                <p class="p-status">평가 기록이 있습니다</p>
                <p class="p-day">마지막 평가일 : {{ patientsInfo.lastbb }}</p>
              </div>
              <div class="item-useful" v-else>
                <img class="icon-item" src="@/assets/images/IA/icon_null_document.png" alt="">
                <p class="p-status-null">평가 기록이 없습니다</p>
                <p class="p-day">마지막 평가일 : --</p>
              </div>
            </div>
            <div class="item-title-b">
              <p class="p-evaluation">손재주 검사-블록 옮기기(BB)</p>
              <img class="icon-info" src="@/assets/images/IA/icon_info_w.png" alt="" @click="showGuide(2)">
            </div>
          </div>
        </div>
        <div class="menu-container">
          <div class="menu-item">
            <div class="item-status">
              <div class="item-useful" v-if="patientsInfo.lastaaut" @click="report('aaut')">
                <img class="icon-item" src="@/assets/images/IA/icon_new_document.png" alt="">
                <p class="p-status">평가 기록이 있습니다</p>
                <p class="p-day">마지막 평가일 : {{ patientsInfo.lastaaut }}</p>
              </div>
              <div class="item-useful" v-else>
                <img class="icon-item" src="@/assets/images/IA/icon_null_document.png" alt="">
                <p class="p-status-null">평가 기록이 없습니다</p>
                <p class="p-day">마지막 평가일 : --</p>
              </div>
            </div>
            <div class="item-title-b">
              <p class="p-evaluation">일상 기능 검사(AAUT)</p>
            </div>
          </div>
          <div class="menu-item">
            <div class="item-status">
              <div class="item-useful" v-if="patientsInfo.lastmal" @click="report('mal')">
                <img class="icon-item" src="@/assets/images/IA/icon_new_document.png" alt="">
                <p class="p-status">평가 기록이 있습니다</p>
                <p class="p-day">마지막 평가일 : {{ patientsInfo.lastmal }}</p>
              </div>
              <div class="item-useful" v-else>
                <img class="icon-item" src="@/assets/images/IA/icon_null_document.png" alt="">
                <p class="p-status-null">평가 기록이 없습니다</p>
                <p class="p-day">마지막 평가일 : --</p>
              </div>
            </div>
            <div class="item-title-s">
              <p class="p-evaluation">상지 사용 능력 검사(MAL)</p>
              <img class="icon-info" src="@/assets/images/IA/icon_info_w.png" alt="" @click="showGuide(3)">
            </div>
          </div>
          <div class="menu-item">
            <div class="item-status">
              <div class="item-useful" v-if="patientsInfo.lastsis" @click="report('sis')">
                <img class="icon-item" src="@/assets/images/IA/icon_new_document.png" alt="">
                <p class="p-status">평가 기록이 있습니다</p>
                <p class="p-day">마지막 평가일 : {{ patientsInfo.lastsis }}</p>
              </div>
              <div class="item-useful" v-else>
                <img class="icon-item" src="@/assets/images/IA/icon_null_document.png" alt="">
                <p class="p-status-null">평가 기록이 없습니다</p>
                <p class="p-day">마지막 평가일 : --</p>
              </div>
            </div>
            <div class="item-title-b">
              <p class="p-evaluation">삶의 질 검사-우울증 검사(SIS)</p>
              <img class="icon-info" src="@/assets/images/IA/icon_info_w.png" alt="" @click="showGuide(4)">
            </div>
          </div>
        </div>
      </div>
      <div class="menu-box" v-else>
        <div class="menu-container">
          <div class="menu-item">
            <div class="item-status">
              <div class="item-useful" v-if="patientsInfo.lastbbs" @click="report('bbs')">
                <img class="icon-item" src="@/assets/images/IA/icon_new_document.png" alt="">
                <p class="p-status">평가 기록이 있습니다</p>
                <p class="p-day">마지막 평가일 : {{ patientsInfo.lastbbs }}</p>
              </div>
              <div class="item-useful" v-else>
                <img class="icon-item" src="@/assets/images/IA/icon_null_document.png" alt="">
                <p class="p-status-null">평가 기록이 없습니다</p>
                <p class="p-day">마지막 평가일 : --</p>
              </div>
            </div>
            <div class="item-title-b">
              <p class="p-evaluation">버그 균형 척도 검사(BBS)</p>
              <img class="icon-info" src="@/assets/images/IA/icon_info_w.png" alt="" @click="showGuide(5)">
            </div>
          </div>
          <div class="menu-item">
            <div class="item-status">
              <div class="item-useful" v-if="patientsInfo.lasttug" @click="report('tug')">
                <img class="icon-item" src="@/assets/images/IA/icon_new_document.png" alt="">
                <p class="p-status">평가 기록이 있습니다</p>
                <p class="p-day">마지막 평가일 : {{ patientsInfo.lasttug }}</p>
              </div>
              <div class="item-useful" v-else>
                <img class="icon-item" src="@/assets/images/IA/icon_null_document.png" alt="">
                <p class="p-status-null">평가 기록이 없습니다</p>
                <p class="p-day">마지막 평가일 : --</p>
              </div>
            </div>
            <div class="item-title-s">
              <p class="p-evaluation">이동성 검사(TUG)</p>
              <img class="icon-info" src="@/assets/images/IA/icon_info_w.png" alt="" @click="showGuide(6)">
            </div>
          </div>
          <div class="menu-item">
            <div class="item-status">
              <div class="item-useful" v-if="patientsInfo.lastftsts" @click="report('ftsts')">
                <img class="icon-item" src="@/assets/images/IA/icon_new_document.png" alt="">
                <p class="p-status">평가 기록이 있습니다</p>
                <p class="p-day">마지막 평가일 : {{ patientsInfo.lastftsts }}</p>
              </div>
              <div class="item-useful" v-else>
                <img class="icon-item" src="@/assets/images/IA/icon_null_document.png" alt="">
                <p class="p-status-null">평가 기록이 없습니다</p>
                <p class="p-day">마지막 평가일 : --</p>
              </div>
            </div>
            <div class="item-title-b">
              <p class="p-evaluation">근력/균형조절 검사 <br/>앉았다 일어나기(FTSTS)</p>
              <img class="icon-info" src="@/assets/images/IA/icon_info_w.png" alt="" @click="showGuide(7)">
            </div>
          </div>
        </div>
        <div class="menu-container">
          <div class="menu-item">
            <div class="item-status">
              <div class="item-useful" v-if="patientsInfo.lasttmwt" @click="report('tmwt')">
                <img class="icon-item" src="@/assets/images/IA/icon_new_document.png" alt="">
                <p class="p-status">평가 기록이 있습니다</p>
                <p class="p-day">마지막 평가일 : {{ patientsInfo.lasttmwt }}</p>
              </div>
              <div class="item-useful" v-else>
                <img class="icon-item" src="@/assets/images/IA/icon_null_document.png" alt="">
                <p class="p-status-null">평가 기록이 없습니다</p>
                <p class="p-day">마지막 평가일 : --</p>
              </div>
            </div>
            <div class="item-title-b">
              <p class="p-evaluation">10m 걷기 검사(10MWT)</p>
              <img class="icon-info" src="@/assets/images/IA/icon_info_w.png" alt="" @click="showGuide(8)">
            </div>
          </div>
          <div class="menu-item">
            <div class="item-status">
              <div class="item-useful" v-if="patientsInfo.lastsmwt" @click="report('smwt')">
                <img class="icon-item" src="@/assets/images/IA/icon_new_document.png" alt="">
                <p class="p-status">평가 기록이 있습니다</p>
                <p class="p-day">마지막 평가일 : {{ patientsInfo.lastsmwt }}</p>
              </div>
              <div class="item-useful" v-else>
                <img class="icon-item" src="@/assets/images/IA/icon_null_document.png" alt="">
                <p class="p-status-null">평가 기록이 없습니다</p>
                <p class="p-day">마지막 평가일 : --</p>
              </div>
            </div>
            <div class="item-title-s">
              <p class="p-evaluation">6분 걷기 검사(6MWT)</p>
              <img class="icon-info" src="@/assets/images/IA/icon_info_w.png" alt="" @click="showGuide(9)">
            </div>
          </div>
          <div class="menu-item">
            <div class="item-status">
              <div class="item-useful" v-if="patientsInfo.lastdgi" @click="report('dgi')">
                <img class="icon-item" src="@/assets/images/IA/icon_new_document.png" alt="">
                <p class="p-status">평가 기록이 있습니다</p>
                <p class="p-day">마지막 평가일 : {{ patientsInfo.lastdgi }}</p>
              </div>
              <div class="item-useful" v-else>
                <img class="icon-item" src="@/assets/images/IA/icon_null_document.png" alt="">
                <p class="p-status-null">평가 기록이 없습니다</p>
                <p class="p-day">마지막 평가일 : --</p>
              </div>
            </div>
            <div class="item-title-b">
              <p class="p-evaluation">동적 보행 검사(DGI)</p>
              <img class="icon-info" src="@/assets/images/IA/icon_info_w.png" alt="" @click="showGuide(10)">
            </div>
          </div>
        </div>
        <div class="menu-container">
          <div class="menu-item">
            <div class="item-status">
              <div class="item-useful" v-if="patientsInfo.lastabc" @click="report('abc')">
                <img class="icon-item" src="@/assets/images/IA/icon_new_document.png" alt="">
                <p class="p-status">평가 기록이 있습니다</p>
                <p class="p-day">마지막 평가일 : {{ patientsInfo.lastabc }}</p>
              </div>
              <div class="item-useful" v-else>
                <img class="icon-item" src="@/assets/images/IA/icon_null_document.png" alt="">
                <p class="p-status-null">평가 기록이 없습니다</p>
                <p class="p-day">마지막 평가일 : --</p>
              </div>
            </div>
            <div class="item-title-b">
              <p class="p-evaluation">활동 특이적 균형 자신감 척도<br/>(ABC Scales)</p>
              <img class="icon-info" src="@/assets/images/IA/icon_info_w.png" alt="" @click="showGuide(11)">
            </div>
          </div>
          <div class="menu-item">
            <div class="item-status">
              <div class="item-useful" v-if="patientsInfo.lastfm_l" @click="report('fm_l')">
                <img class="icon-item" src="@/assets/images/IA/icon_new_document.png" alt="">
                <p class="p-status">평가 기록이 있습니다</p>
                <p class="p-day">마지막 평가일 : {{ patientsInfo.lastfm_l }}</p>
              </div>
              <div class="item-useful" v-else>
                <img class="icon-item" src="@/assets/images/IA/icon_null_document.png" alt="">
                <p class="p-status-null">평가 기록이 없습니다</p>
                <p class="p-day">마지막 평가일 : --</p>
              </div>
            </div>
            <div class="item-title-s">
              <p class="p-evaluation">전반적 하지 손상 검사(FM)</p>
              <img class="icon-info" src="@/assets/images/IA/icon_info_w.png" alt="" @click="showGuide(12)">
            </div>
          </div>
        </div>
      </div>
      <div class="guide-dialog" v-show="isGuide">
        <div class="bs-flex">
          <h5 v-html="guideTitle"></h5>
          <img class="btn-close" src="@/assets/images/IA/btn_close.png" alt="" @click="isGuide= false">
        </div>
        <p v-html="guideScript"></p>
      </div>
    </div>
  </div>
</template>

<script>
import {firebase} from "@/firebase/firebaseConfig";
import {getDate} from "@/lib/prettyDate";

export default {
  name: "UserMain",
  data() {
    return {
      fbCollection: 'patients',
      fbUserUid: this.$store.state.user.uid,
      isTypeUpper: true,
      isGuide: false,
      guideText: [
        {
          title: '전반적 상지 손상 검사(FM)',
          script: '뇌졸중 후 환자의 회복을 평가 및 측정하는 도구로 상지의 운동기능을 측정하기위해 사용되는 평가도구입니다.</br>' +
              '상지의 반사, 굴곡 시너지, 신전 시너지 움직임 및, 손목과 손가락의 움직임, 협응성등을 평가합니다.</br>' +
              '66점 만점으로 점수가 낮을수록 기능이 낮고, 점수가 높을수록 환자의 운동기능이 높음을 의미합니다.'
        },
        {
          title: '상지 운동 검사(WMFT)',
          script: '상지의 기능적 운동 능력을 평가하는 것으로 해당 움직임 시 시간과 움직임의 질을 평가하는 도구입니다.  움직임 시간이 짧을수록 움직임의 질 점수가 높을 수록 기능의 수준이 높다는 것을 의미합니다.'
        },
        {
          title: '손재주 검사 - 블록 옮기기(BB)',
          script: '박스와 블록 검사 (Box and Block, BB)은 손상측 손과 비손상측 손의 잡기(grasping) 능력을 보기 위해 사용되는 평가도구 입니다. 1분 동안 옮긴 큐브의 개수가 높을수록 환자의 잡기 능력이 높음을 의미합니다.'
        },
        {
          title: '상지 사용 능력 검사(MAL)',
          script: '개인의 실제 일상생활 속에서 손상측 상지를 얼마나 많이 그리고 잘 사용하였는지 평가하는 도구입니다. 점수가 높을 수록 손상측 상지를 많이 사용하며 잘 사용함을 의미합니다.'
        },
        {
          title: '삶의 질 검사 - 우울증 검사(SIS)',
          script: '뇌졸중 환자들을 대상으로 뇌졸중에 의한 신체적인 면, 일상생활 동작, 감성, 의사소통, 기억, 사회 참여 등의 9가지 영역에서 변화 정도를 측정하기 위해 고안된 평가척도입니다.</br>' +
              '각 영역에 따라 척도가 달라질 수 있지만, 9번 영역을 제외한 나머지 영역은 점수가 낮을수록 뇌졸중으로 인해 받게 되는 영향이 적음을 의미합니다. '
        },
        {
          title: '버그 균형 척도(BBS)',
          script: 'Berg balance scale은 성인의 정적 균형과 낙상 위험을 평가하는 14개 항목의 객관적인 척도입니다. 각 항목당 0에서 4까지 5점 척도로 이루어져있으며, 56점 만점입니다. ' +
              'BBS 0-20점은 균형 능력 손상, 21-40점은 허용 가능한 균형, 41-56점은 균형 능력이 좋음을 나타냅니다. '
        },
        {
          title: '이동성 검사(TUG)',
          script: 'Timed Up And Go Test는 사람의 이동성을 측정하는데 사용되는 하지평가도구로 정적인 균형과 동적인 균형을 모두 필요로 합니다. ' +
              '의자에서 일어나 3m 거리에 있는 장애물까지 걸어가 장애물을 돌아서 다시 의자에 앉는 방법입니다. ' +
              '제한시간 없이 시간을 측정하며, 점수의 해석은 ‘10초 이내 = 스스로 완전히 활동 가능, 20초 이내 = 기본적 활동 가능, 30초 이상 = 보조 필요로 할 수 있다’ 입니다. '
        },
        {
          title: '근력/균형조절 검사-앉았다 일어나기(FTSTS)',
          script: 'Five Times Sit To Stand Test (5TSTS)는 노인뿐만 아니라 뇌성마비, 뇌졸중, 골관절염 등 환자들에게 기능적인 하지의 근력을 측정하고 균형조절 능력을 평가해 낙상의 재발을 예측하는 평가도구 입니다. ' +
              '의자에서 일어났다가 앉는 동작을 5번 수행할 때의 시간을 측정하는 평가로 하지의 힘으로만 일어나도록 합니다. '
        },
        {
          title: '10m 걷기 검사(10MWT)',
          script: '10Meter Walk Test (10MWT)는 단거리 보행 속도 및 능력을 보는 평가도구입니다. 10M(10미터)의 거리를 측정자의 도움없이 독립적으로 걷고 일반적으로 총 3회 10M를 걸을 때의 시간을 측정하여 속도를 계산합니다. </br>' +
              '좀 더 정확히는 시작 위치에서부터 2M와 8M 사이의 거리를 대상자가 걸을 때의 시간(시작과 끝 2M는 제외)을 측정하여 속도를 계산하는 것이 일반적입니다. 대상자의 평소 걷는 걸음으로 3회 10m를 걷는 것을 측정한 후, 빠른 속도로 3회 걷는 것을 측정합니다. 평소 걸음과 빠른 걸음 각각 평균 속도를 계산하며, 초기 평가 후 1개월마다 재평가를 시행합니다. '
        },
        {
          title: '6분 걷기 검사(10MWT)',
          script: '6Minute Walk Test (6MWT), 6분 걷기 검사는 환자의 운동 능력을 객관적으로 측정하는 평가도구입니다. 보행 운동과 관련한 계통의 반응을 총체적으로 반영하고 일상생활에 필요한 운동 능력을 반영합니다. </br>' +
              '6분 동안 환자가 걸은 거리를 측정하고 1분마다 피로도와 호흡 곤란도를 측정합니다. 만약 중간에 측정을 중단할 경우 해당 거리를 기록하고 그에 대한 사유를 기록하며 검사를 종료합니다. '
        },
        {
          title: '동적 보행 검사(DGI)',
          script: 'Dynamic Gait Index (DGI), 동적 보행 검사는 평평한 지면에서의 보행, 보행 속도 변경하기, 보행하면서 머리를 옆으로 돌리기, 보행하면서 상하로 머리를 움직이기, 보행하다가 한 발을 축으로 해서 돌기, 장애물 위를 지나 걷기, 장애물 주위를 걷기, 계단 오르기 같은 과제가 포함된 보행능력을 정량화 하여 측정할 수 있는 도구입니다. ' +
              '0점에서 3점까지 4점 척도로, 점수가 높을수록 보행에 손상이 적은 것을 의미합니다. '
        },
        {
          title: '활동 특이적 균형 자신감 척도(ABC Scales)',
          script: 'ABC scale은 균형을 잃지 않고 다양한 활동을 수행하는 것에 대한 개인의 균형 자신감을 평가하는 16가지 항목의 자가 보고 측정 검사입니다. ' +
              '항목은 0에서 100까지 등급 척도를 이용하며, 점수가 높을수록 균형 능력에 자신이 있음을 나타냅니다. '
        },
        {
          title: '전반적 하지 손상 검사(FM)',
          script: 'Fugl-Meyer Lower Extremity (FM)는 총 17개의 항목으로 구성되며. 하지의 반사, 굴곡 시너지, 신전시너지의 움직임 및 무릎과 발목의 움직임, 협응성 등을 평가합니다. ' +
              '0점 (수행할 수 없음), 1점 (부분적 수행 가능), 2점 (완전히 수행 가능)으로 3점 척도를 사용합니다. </br>' +
              '총 34점 만점으로 점수가 낮을수록 운동기능이 낮고, 점수가 높을수록 운동기능이 높음을 의미합니다. '
        },

      ],
      guideTitle: '',
      guideScript: '',
      selTool: '',
      isExistInfo: false,
      patientsInfo: {},
      patientKey: '',
    }
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      const self = this;
      const db = firebase.firestore();
      db.collection(self.fbCollection).where('userInfo.uid', '==', self.fbUserUid)
          .get().then(async (querySnapshot) => {
        if (querySnapshot.size !== 0) {
          self.isExistInfo = true;
          querySnapshot.forEach((doc) => {
            const _data = doc.data();
            _data["docId"] = doc.id;
            self.patientKey = doc.id;
            const date = new Date(_data.regDate.seconds * 1000);
            _data.regDate = getDate(date);
            self.patientsInfo = _data
            db.collection(self.fbCollection).doc(self.patientKey).update({lastLog: firebase.firestore.Timestamp.fromDate(new Date())});
          });
        } else {
          self.isExistInfo = false;
          alert('환자정보 없습니다. 치료사에게 문의하세요.')
        }
      })
    },
    showGuide(toolIndex) {
      const self = this;
      self.isGuide = true;
      self.guideTitle = self.guideText[toolIndex].title
      self.guideScript = self.guideText[toolIndex].script
    },
    report(toolName) {
      const self = this;
      if (!self.isExistInfo) {
        return alert('평가기록이 없습니다.');
      }
      self.selTool = toolName
      self.$router.push('/user/evaluation/' + self.patientKey + '/' + self.selTool)
    },
  }
}
</script>

<style scoped>
.modal-cover {
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.user-main {
  position: relative;
  overflow: hidden;
}
.user-main-frame {
  position: relative;
  width: 1140px;
  margin: 0 auto;
  /*background: url('../../assets/images/IA/img_user_bk.png') center no-repeat;*/
  padding: 60px 98px 50px;
}

.background-img {
  width: 1140px;
  height: 1026px;
  position: absolute;
  top: 0;
  left: 0;
  object-fit: fill;
}

.menu-guide {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-bottom: 40px;
}

.menu-pager-btn {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding-bottom: 30px;
}

.menu-pager-btn img {
  width: 78px;
  margin-right: 48px;
}

.menu-pager-btn img:last-child {
  margin-right: 0;
}

.p-guide {
  font-size: 16px;
  line-height: 28px;
  color: #fff;
  font-weight: 400;
}

.menu-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 15px;
}

.menu-container:first-child {
  margin: 0;
}

.menu-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 15px;
}

.menu-container:last-child {
  margin-right: auto;
}

.menu-item {
  width: 296px;
  height: 204px;
  background: #fff;
  margin-right: 13px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.menu-item:last-child {
  margin-right: 0 !important;
}

.item-status {
  width: 100%;
  height: 150px;
  font-size: 13px;
  line-height: 20px;
  color: #000;
  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 0;
  text-align: center;

  cursor: pointer;
}

.p-status {
  padding-top: 15px;
  font-weight: 400;
}

.p-status-null {
  color: #848484;
  padding-top: 15px;
  font-weight: 400;
}

.p-day {
  color: #8D8D8D;
}

.p-evaluation {
  width: 228px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
  color: #fff;
}

.icon-item {
  width: 32px;
}

.icon-info {
  width: 20px;
  height: 20px;
  margin-left: 8px;
  cursor: pointer;
}

.item-title-b {
  width: 100%;
  height: 54px;
  background: #0069CA;
  border-radius: 0 0 8px 8px;
  display: flex;
  flex-direction: row;
  justify-items: center;
  align-items: center;
  padding: 0 20px;
}

.item-title-s {
  width: 100%;
  height: 54px;
  background: #00ABEB;
  border-radius: 0 0 8px 8px;
  display: flex;
  flex-direction: row;
  justify-items: center;
  align-items: center;
  padding: 0 20px;
}

.btn-ue, .btn-le {
  cursor: pointer;
}

.le-box {
  width: 100%;
  height: 423px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.le-box h5 {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 36px;
  letter-spacing: 0.0125em;
  text-transform: uppercase;
  color: #B1B1B1;
}

.guide-dialog {
  width: 732px;
  background: #FFFFFF;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  padding: 23px 20px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.bs-flex {
  display: flex;
}

.btn-close {
  width: 24px;
  height: 24px;
  margin-left: auto;
  cursor: pointer;
}

.guide-dialog h5 {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: center;
  letter-spacing: 0.001em;
  color: #000000;
  margin-bottom: 5px;
}

.guide-dialog p {
  max-width: 658px;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  letter-spacing: 0.0025em;
  color: #8D8D8D;
  margin: 0;
  word-break: keep-all;
}

.item-useful {
  padding-top: 31.5px;
  width: 100%;
  height: 100%;
}
</style>
